// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2HMrD","inputWrap":"Table_inputWrap__3wACa","col":"Table_col__1CigQ","bmiTooltip":"Table_bmiTooltip__192X-"};